module.exports = __webpack_public_path__ + "img/three2Blue.e5bf1889.jpg";